<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Button, ButtonGroup } from '@Shelly/shelly-design-system';
	import { resolveTrvValveCommandState } from 'src/helpers/trv_valve_command_state';
	import { capFirstChar } from 'src/helpers/utilities';

	export let disabled = false;
	export let currentPosition: number | undefined;
	export let pendingPosition: number | undefined;
	export let isLoading = false;
	export let onClose: () => void;
	export let onStop: () => void;
	export let onOpen: () => void;

	$: commandState = resolveTrvValveCommandState({
		currentPosition,
		pendingPosition,
		rpcPending: isLoading,
		disabled,
	});
</script>

<div class="trv-valve-commands">
	<ButtonGroup
		id="trv-valve-commands"
		class="width-full"
		noWrap
		aria-label={$format('label_trv_valve_controls', { default: 'Valve controls' })}
	>
		<Button
			id="trv-close-valve"
			size="m"
			width="full"
			icon="fas fa-circle-xmark"
			leftIconSize="s"
			class={commandState.closeActive ? 'active' : ''}
			disabled={commandState.closeDisabled}
			loading={commandState.closeLoading}
			aria-pressed={commandState.closeActive}
			aria-label={capFirstChar($format('button_close_valve', { default: 'Close valve' }))}
			on:click={onClose}
		>
			{capFirstChar($format('button_close', { default: 'Close' }))}
		</Button>
		<Button
			id="trv-stop-valve"
			size="m"
			width="full"
			icon="fas fa-stop"
			leftIconSize="s"
			class={commandState.stopActive ? 'active' : ''}
			disabled={commandState.stopDisabled}
			loading={commandState.stopLoading}
			aria-pressed={commandState.stopActive}
			aria-label={$format('label_stop_valve', { default: 'Stop valve' })}
			on:click={onStop}
		>
			{capFirstChar($format('button_stop', { default: 'Stop' }))}
		</Button>
		<Button
			id="trv-open-valve"
			size="m"
			width="full"
			icon="fas fa-circle-check"
			leftIconSize="s"
			class={commandState.openActive ? 'active' : ''}
			disabled={commandState.openDisabled}
			loading={commandState.openLoading}
			aria-pressed={commandState.openActive}
			aria-label={capFirstChar($format('button_open_valve', { default: 'Open valve' }))}
			on:click={onOpen}
		>
			{capFirstChar($format('button_open', { default: 'Open' }))}
		</Button>
	</ButtonGroup>
</div>

<style>
	.trv-valve-commands :global(.button-group .button.disabled-overlay:not(.custom):not(.active)) {
		color: var(--color-theme-text-disabled);
		-webkit-text-fill-color: var(--color-theme-text-disabled);
	}
</style>
